import {observable, action} from 'mobx';
import {endpoints, types} from 'shared/core';
import {PerformanceReviewCycle} from 'stores/performance_reviews';
import {DomainStore} from 'shared/store';

class AdminContainerState {
  agent;
  match;
  history;
  store = new DomainStore();

  @observable cycle;
  @observable endCycleModalOpen = false;
  @observable updateDueDateModalOpen = false;
  @observable dueDate;
  @observable isEnding = false;
  @observable reviewee;
  @observable errors = {};

  @observable selectedReviewee;
  @observable reviewerSelectionModalOpen = false;
  @observable addRevieweeModalOpen = false;

  receiveProps({match, history, scope}) {
    this.match = match;
    this.history = history;
    this.scope = scope;
  }

  @action async load() {
    const id = this.match.params.cycleId;

    await this.store._compose([
      endpoints.PERFORMANCE_REVIEWS.CYCLE.with(id)
    ]);

    this.cycle = new PerformanceReviewCycle(
      this.store._getSingle(types.PERFORMANCE_REVIEWS.CYCLE)
    );
  }

  @action openEndCycleModal() {
    this.endCycleModalOpen = true;
  }

  @action closeEndCycleModal() {
    this.endCycleModalOpen = false;
  }

  @action openUpdateDueDateModal() {
    this.dueDate = this.cycle.dueDate;
    this.updateDueDateModalOpen = true;
  }

  @action closeUpdateDueDateModal() {
    this.dueDate = null;
    this.updateDueDateModalOpen = false;
  }

  @action setDueDate(date) {
    this.dueDate = date;
  }

  @action openReviewerSelectionModal(reviewee) {
    this.selectedReviewee = reviewee;
    this.reviewerSelectionModalOpen = true;
  }

  @action closeReviewerSelectionModal() {
    this.reviewerSelectionModalOpen = false;
  }

  @action onReviewersSelected() {
    this.interactiveAgent.refresh();
    this.closeReviewerSelectionModal();
  }

  @action openAddRevieweeModal() {
    this.addRevieweeModalOpen = true;
  }

  @action closeAddRevieweeModal() {
    this.addRevieweeModalOpen = false;
  }

  @action onRevieweeAdded() {
    this.interactiveAgent.refresh();
    this.closeAddRevieweeModal();
  }

  setInteractiveAgent(interactiveAgent) {
    this.interactiveAgent = interactiveAgent;
  }

  @action async endCycle() {
    this.isEnding = true;

    await this.store.post(
      this.cycle.link('end'),
      types.PERFORMANCE_REVIEWS.CYCLE,
      this.cycle
    );

    this.history.push(`/reviews/${this.cycle.id}`);
  }

  @action async updateDueDate() {
    const {model, errors} = await this.store.post(
      this.cycle.link('updateDueDate'),
      types.PERFORMANCE_REVIEWS.CYCLE,
      {...this.cycle, dueDate: this.dueDate}
    );

    this.errors = errors;
    if (model) {
      this.cycle.merge(model);
      this.closeUpdateDueDateModal();
    }
  }

  @action async removeReviewee(reviewee) {
    await this.store.destroy(reviewee);
    await this.load();
  }
}

export default AdminContainerState;
